import { createFileRoute } from "@tanstack/react-router";
import { PrivacidadePage } from "@/components/pages/PrivacidadePage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Privacy Policy — Kentro Sistemas",
    desc: "Kentro Platform Privacy Policy: how we collect, use, share and protect your personal data under Brazil's LGPD.",
    ogTitle: "Privacy Policy — Kentro Sistemas",
    ogDesc: "How Kentro Sistemas handles personal data on the Service Management Platform.",
  },
  es: {
    title: "Política de Privacidad — Kentro Sistemas",
    desc: "Política de Privacidad de la Plataforma Kentro: cómo recopilamos, usamos, compartimos y protegemos tus datos personales conforme a la LGPD.",
    ogTitle: "Política de Privacidad — Kentro Sistemas",
    ogDesc: "Cómo Kentro Sistemas trata los datos personales en la Plataforma de Gestión de Atención.",
  },
} as const;

export const Route = createFileRoute("/$locale/privacidade")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/privacidade` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/privacidade` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/privacidade` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/privacidade` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/privacidade` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/privacidade` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Privacidade', item: `${SITE}/${loc}/privacidade` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/privacidade`,
            url: `${SITE}/${loc}/privacidade`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: PrivacidadePage,
});
